import camelcaseKeys from 'camelcase-keys';
import { useEffect, useState } from 'react';
import { getUnitAssetsService } from '../services';

const useGetUnitAssets = (
  unitId: number | undefined
): { assets: Array<any>; isFetching: boolean } => {
  const [assets, setAssets] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(false);

  useEffect(() => {
    if (unitId) {
      setIsFetching(true);
      getUnitAssetsService(
        { unitId },
        {
          successAction: (response) => {
            if (response?.success && response?.data) {
              const resultData = response.data.map((result) => camelcaseKeys(result));
              setAssets(resultData);
            } else {
              setAssets([]);
            }
            setIsFetching(false);
          },
          errorAction: (error) => {
            setAssets([]);
            setIsFetching(false);
          }
        }
      );
    }
  }, [unitId]);
  return { assets, isFetching };
};

export default useGetUnitAssets;
